module.exports = window["bonnet-webcomponent-react-dom"];